import * as React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import ErrorMessageProvider from 'root/apps/PurchaseOrder/ShipmentHistory/contexts/ErrorMessage';
import { useDisableSave } from 'root/apps/PurchaseOrder/ShipmentHistory/hooks/use-disable-save';
import OverviewDataProvider from 'root/apps/PurchaseOrder/ShipmentHistory/tabs/View/contexts/OverviewData';

import ShipmentHistoryListing from './Listing';
import ShipmentHistoryView from './View';

interface Props {
  shipmentId?: number;
}

export type Page = 'listing' | 'view';

const ShipmentHistory: React.FC<Props> = ({ shipmentId }) => {
  const [page, setPage] = React.useState<Page>(shipmentId ? 'view' : 'listing');

  useDisableSave();

  return (
    <ErrorMessageProvider>
      {page === 'listing' ? <ShipmentHistoryListing setPage={setPage} /> : null}
      {page === 'view' ? (
        <OverviewDataProvider>
          <ShipmentHistoryView setPage={setPage} />
        </OverviewDataProvider>
      ) : null}
    </ErrorMessageProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: ShipmentHistory,
  selector: '[data-react-root="ShipmentHistory"]',
});

history.onChangeState(
  [
    {
      name: 'purchase.views.purchase',
      form_name: 'view',
      tab: 'shipment_history',
      shipment_id: undefined,
    },
  ],
  (filters) => {
    RenderedComponent.mount({ props: { shipmentId: filters.shipment_id } });
  },
  () => {
    RenderedComponent.unmount();
  }
);
